import { ISummaryDetail } from "@DataPages/types/inventory/models/reconciliation";

const propertiesMap: Partial<Record<keyof ISummaryDetail, string>> = {
	storeNumber: "Store Number:",
	inventoryDate: "Inventory Date",
	reconciliationCompletionDate: "Reconciliation Completion Date",
	dealership: "Dealership",
	// Common properties for all types of vehicles (New and Used)
	physicalInventoryCountOnLot: "Physical Inventory Count (On Lot)",
	physicalInventoryCountOffLot: "Physical Inventory Count (Off Lot)",
	unitsOnScheduleNotOnLot: "Units on Schedule Not on Lot",
	unitsOnLotNotOnSchedule: "Units on Lot Not on Schedule",
	unitsOffLotNotOnSchedule: "Units Off Lot Not on Schedule",
	totalSchedule: "Total",
	perGeneralLedgerSchedule: "Per General Ledger Schedule",
	differenceSchedule: "Difference (Should Equal Zero)",
	// Properties for New vehicles
	physicalInventoryOnLot: "Physical Inventory On Lot",
	physicalInventoryOffLot: "Physical Inventory Off Lot",
	unitsInPhysicalInventoryNotOnMfg: "Units in Physical Inventory Not on Mfg",
	unitsOffPhysicalInventoryNotOnMfg: "Units on Mfg Not in Physical Inventory",
	totalManufacture: "Total",
	perManufacturerReport: "Per Manufacturer Report",
	differenceManufacture: "Difference (Should Equal Zero)",
};

export { propertiesMap };
